var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vipvipvip"},[_c('div',{staticClass:"show"},[_vm._m(0),_c('div',{staticClass:"show-button",attrs:{"hover-class":"hover"},on:{"click":_vm.navigatePay}},[_vm._v("立即开通VIP")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-title"},[_c('span',[_vm._v("开通VIP查看")]),_c('span',[_vm._v("全部数据")])])
}]

export { render, staticRenderFns }